import * as dayjs from "dayjs";

export const isRegistrationOpen = () =>
  dayjs().isAfter(dayjs("2026-10-12 23:59")) &&
  dayjs().isBefore(dayjs("2026-12-24 23:59"));
